export default __webpack_public_path__ + "static/media/partner1.876f9b5f.png";